// import store from "@/store";
import Vue from '@/main'
var Web3 = require('web3')
const promisify = (inner) =>
  new Promise((resolve, reject) =>
    inner((err, res) => {
      if (err) {
        reject(err)
      } else {
        resolve(res)
      }
    })
  )

export default {
  async connectWeb3 () {
    let ethereum = this.getWeb3Object()
    var web3 = new Web3(ethereum)
    if (ethereum) {
      try {
        var t = await ethereum.request({ method: 'eth_requestAccounts' })
        if (!t) {
          Vue.$prompt.error('MetaMask enable Error')
          return null
        }
        var address = await promisify(cb => web3.eth.getCoinbase(cb))
        return address
      } catch (e) {
        console.log(e.message)
        Vue.$prompt.error(e.message)
        return null
      }
    } else {
      window.open('https://metamask.app.link/dapp/' + window.location.href)
    }
    return { error }
  },
  getAddress () {
    let ethereum = this.getWeb3Object()
    console.log(Web3)
    if (!ethereum) return
    var web3 = new Web3(ethereum)
    window.wallet = web3
    return new Promise((resolve) => {
      web3.eth.getAccounts(async (error, result) => {
        if (!error && result[0]) {
          var networkId = await promisify(cb => web3.eth.getChainId(cb))
          var address = await promisify(cb => web3.eth.getCoinbase(cb))
          ethereum.once('accountsChanged', this.accountsChanged)
          ethereum.on('chainChanged', this.chainChanged)
          ethereum.on('disconnect', this.disconnect)
          let walletType = 'metamask'
          // store.dispatch("setMaskInfo", {networkId, address, walletType});
          // this.dealDomainTip(networkId)
          resolve(result[0])
        } else {
          resolve(null)
        }
      })
    })
  },
  dealDomainTip (networkId) {
    let link = window.location.href
    if ((link.indexOf('m.worldkey.ai') > -1 || link.indexOf('mobile.worldkey.ai') > -1) && parseInt(networkId) === 4) {
      Vue.$networkPrompt.showMainTip()
    }
    if ((link.indexOf('m.worldkey.ai') < 0 && link.indexOf('mobile.worldkey.ai') < 0) && parseInt(networkId) === 1) {
      Vue.$networkPrompt.showTestTip()
    }
  },
  getWeb3Object () {
    if (window.ethereum) {
      return window.ethereum
    } else if (window.web3) {
      return window.web3.currentProvider
    } else {
      return null
    }
  },
  accountsChanged (accounts) {
    // if(!store.state.user.userInfo) return;
    // store.dispatch("logout")
    Vue.$prompt.success('You have been logged out.')
    Vue.$router.push('/')
  },
  chainChanged (channelId) {
    window.location.reload()
    // let config = store.state.user.config;
    // if (parseInt(channelId) != parseInt(config.networkId) ) {
    //   alert(channelId)
    //   Vue.$prompt.success('Network Wrong! Change network to' + Tool.networkName(config.networkId))
    // }
  },
  disconnect (error) {
    // if(!store.state.user.userInfo) return;
    // store.dispatch("logout");
    Vue.$prompt.success('You have been logged out.')
    Vue.$router.push('/')
  },
  async getTransaction (tx) {
    let web3 = this.getWeb3()
    try {
      // return await web3.eth.getTransaction(tx)
      return await promisify(cb => web3.eth.getTransaction(tx, cb))
    } catch (e) {
      return { error: e.message }
    }
  },
  async getTransactionReceipt (tx) {
    let web3 = this.getWeb3()
    try {
      return await promisify(cb => web3.eth.getTransactionReceipt(tx, cb))
    } catch (e) {
      return { error: e.message }
    }
  },
  async decodeLog (inputs, hexString, options) {
    let web3 = this.getWeb3()
    try {
      return await promisify(cb => web3.eth.abi.decodeLog(inputs, hexString, options, cb))
    } catch (e) {
      return { error: e.message }
    }
  },
  getWeb3 () {
    return window.wallet
  },
  async loginWallet (address) {
    let timestamp = parseInt(new Date().getTime() / 1000)
    var message = ''// store.state.config.LoginMessage + " " + timestamp;
    try {
      let signature = await this.sign(message, address)
      return {
        signature: signature,
        timestamp: timestamp
      }
    } catch (e) {
      return { error: e.message }
    }
  },
  async sign (message, address) {
    var web3 = window.wallet
    try {
      address = web3.utils.toChecksumAddress(address)
      var signature = await promisify(cb => web3.eth.personal.sign(message, address, cb))
      // var signature = await web3.eth.personal.sign(message, address);
      return signature
    } catch (e) {
      if (e.code !== 4001) {
        Vue.$prompt.error(e.message)
      }
      return null
    }
  },
  async checkWeb3 (web3) {
    if (window.ethereum) {
      try {
        // var isListening = await web3.eth.net.isListening();
        // var isListening = await promisify(cb => web3.eth.net.isListening(cb))
        // if (!isListening) return false;
        return true
      } catch (error) {
      }
    }
    return false
  },
  async monitorWeb3 () {
    let web3 = window.wallet
    if (typeof web3 === 'undefined' || !web3) return
    var result = await this.checkWeb3(web3)
    if (!result) {
      var result = await this.connectWeb3()
      if (result.error) return
      web3 = window.wallet
    }
    let config = ''// store.state.config;

    var networkId = await promisify(cb => web3.eth.getChainId(cb))
    if (networkId != config.networkId) {
      // alert('Change network to' + Tool.networkName(config.networkId))
    }
  },
  async changeNetwork (network) {
    try {
      let result = await window.ethereum.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId: '0x' + network.channelId.toString(16) }]
      })
      return result
    } catch (e) {
      if (e.code == 4001) return { error: e.message }
      try {
        let result = await window.ethereum.request({
          method: 'wallet_addEthereumChain',
          params: [{
            chainId: '0x' + network.channelId.toString(16),
            chainName: network.name,
            nativeCurrency: {
              name: network.coinSymbol,
              symbol: network.coinSymbol,
              decimals: 18
            },
            rpcUrls: [ network.rpc ]
          }]
        })
        return result
      } catch (e) {
        return { error: e.message }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js